import Vue from 'vue'
export default {
    setSearchPhone (state, data) {  //添加学生搜索手机号
        state.searchphone = data
    },
}

